module.exports = __webpack_public_path__ + "static/img/08.02c7033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/08.jpg
// module id = VQF7
// module chunks = 0